import { render, staticRenderFns } from "./DarkTechCoop.vue?vue&type=template&id=59401104&scoped=true&"
import script from "./DarkTechCoop.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkTechCoop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59401104",
  null
  
)

export default component.exports